import React from "react";
import ReactDOM from "react-dom/client";
import { GlobalStyles, ThemeProvider } from "@mui/material";
import { HelmetProvider } from "react-helmet-async";
import { Provider } from "react-redux";
import { RouterProvider } from "react-router-dom";

import { globalStyles } from "./theme/globalStyles";
import { store } from "./redux-store";
import { router } from "./router";
import { theme } from "./theme";
import "swiper/css";
import "./theme/style.css";

import "@fontsource/mulish/400.css";
import "@fontsource/mulish/500.css";
import "@fontsource/mulish/600.css";
import "@fontsource/mulish/700.css";

ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <HelmetProvider>
      <Provider store={store}>
          <ThemeProvider theme={theme}>
            <RouterProvider router={router} />
            <GlobalStyles styles={globalStyles} />
          </ThemeProvider>
      </Provider>
    </HelmetProvider>
  </React.StrictMode>
);
